/** @format */

import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import AdminPageToolbar from './AdminPageToolbar/AdminPageToolbar';
import { getAttributeFromObject } from '../../../helpers/objectHelpers';
import './AdminPage.css';

export default class AdminPage extends Component {
  getStore() {
    return this.props.store;
  }

  renderToolbar = () => {
    return <AdminPageToolbar store={this.getStore()} />;
  };

  renderTableHeader = () => {
    const store = this.getStore();
    const header = store.tableKeys.map((key, index) => {
      return (
        <Table.HeaderCell
          className="table-head-cell"
          onClick={() => store.sortItemsBy(key.prop, key.order)}
          key={index}
        >
          {key.label}
        </Table.HeaderCell>
      );
    });

    return <Table.Row>{header}</Table.Row>;
  };

  renderTableBody = () => {
    const store = this.getStore();
    const items = store.searchedItems;
    const tableKeys = store.tableKeys;

    return items.map((item, index) => {
      return (
        <Table.Row
          key={index}
          onClick={() => {
            store.toggleEditModal();
            store.loadCurrentItem(item.uid);
          }}
        >
          {tableKeys.map((key, index) => {
            return (
              <Table.Cell key={key.prop + '_' + index}>
                {getAttributeFromObject(key.prop, item)}
              </Table.Cell>
            );
          })}
        </Table.Row>
      );
    });
  };

  renderTableModal = () => {
    //
  };

  render() {
    return (
      <div>
        {this.renderToolbar()}
        <Table sortable selectable size="small" className="app-manage-table">
          <Table.Header className="table-head">
            {this.renderTableHeader()}
          </Table.Header>
          <Table.Body>{this.renderTableBody()}</Table.Body>
        </Table>
        {this.renderTableModal()}
      </div>
    );
  }
}
